module.exports = __webpack_public_path__ + "img/logo-tiki-bistro.1c5fcf96.png";